<template>
  <header>
    <NavBar />
    <div v-if="authorizationNeeded" id="google-auth" class="google-banner p-2 text-center">
      Google authorization is needed for Auger. Please
      <a @click="startGoogleAuthorization">authorize now</a>.
    </div>
    <div v-else-if="grantIncomplete" id="google-reauth" class="google-banner p-2 text-center">
      Reconnect Google so connected apps, such as Claude, can read your calendar and mail.
      <a @click="startGoogleAuthorization">Reconnect now</a>.
    </div>
  </header>
</template>

<script setup lang="ts">
import { toast } from "vue-sonner"
import { storeToRefs } from "pinia"
import NavBar from "@/components/app/NavBar.vue"
import { useGoogle } from "@/composables/useGoogle"
import { client } from "@/init/apollo"
import { useGoogleStore } from "@/stores/google"

const { authorize } = useGoogle({ client, toast })

const { authorizationNeeded, grantIncomplete } = storeToRefs(useGoogleStore())

function startGoogleAuthorization() {
  authorize()
}
</script>

<style>
#app > header {
  background-color: var(--auger-dark);
  min-height: 84px;
}
/* The yellow stays the same in dark mode, so the text must not follow the
   page's light dark-mode text: text-on-warning is dark in both modes. */
.google-banner {
  background-color: var(--auger-warning);
  color: var(--auger-text-on-warning);
}
.google-banner a {
  color: inherit;
  cursor: pointer;
  font-weight: 600;
  text-decoration: underline;
}
@media screen and (max-width: 782px) {
  #app > header {
    min-height: auto;
  }
}
</style>
